/** Invitation — document knowledge definition. Pure data. */
export default {
  id: 'invitation',
  name: 'Invitation',
  description: 'A personal card inviting guests to a wedding, party, or ceremony.',
  purpose: 'Event Invitation',
  recommendedSizes: [
    { name: '5×7 in', width: 1500, height: 2100, unit: 'px' },
    { name: 'Square', width: 1600, height: 1600, unit: 'px' },
  ],
  supportedOrientations: ['portrait', 'square'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Title', 'Names', 'Date', 'Venue', 'RSVP'],
};
